import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import ArctitectureGlassBanner from "../../../Assets/Product_Images/ArctitectureGlass/ArctitectureGlassBanner.webp";
import ArctitectureGlass1 from "../../../Assets/Product_Images/ArctitectureGlass/ArctitectureGlass1.jpg";
import ArctitectureGlass2 from "../../../Assets/Product_Images/ArctitectureGlass/ArctitectureGlass2.jpg";
import ArctitectureGlass3 from "../../../Assets/Product_Images/ArctitectureGlass/ArctitectureGlass3.webp";
import { Link } from "react-router-dom";

const Arctitecture_Glass = () => {
  return (
    <div>
      <Header />
      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${ArctitectureGlassBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  / <span className="text-white">Arctitecture Glass</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start  */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5
                  style={{
                    color: "#153fa4",
                    fontFamily: "Segoe UI, sans-serif",
                    fontSize: "40px",
                    fontWeight: "700",
                    marginBottom: "15px",
                  }}
                >
                  Arctitecture Glass
                </h5>
                <p>
                  Used widely in architectural design, glass serves both
                  functional and ornamental purposes. Covering a range of
                  architectural requirements, this kind of glass includes many
                  formats—float, tempered, laminated, insulated, and smart. Its
                  uses span facades, curtain walls, skylights, balustrades, and
                  partitions.
                </p>
                <p>
                  Architectural glass's ability to give thermal and acoustic
                  insulation while also offering natural lighting is one of its
                  great advantages. Sustainable and green building
                  certifications depend on improved energy efficiency in
                  structures provided by innovations such as double-glazed units
                  (DGU) and low-emissivity (low-E) coatings. It also encourages
                  contemporary design trends, including transparency, openness,
                  and lightness.
                </p>
                <p>
                  Architectural glass is designed to withstand breakage, lower
                  fire hazards, and avoid falls in high-rise structures,
                  therefore enhancing safety. Thanks to advances in glass
                  technology, architects may now include electrochromic glass—an
                  intelligent feature whereby transparency changes with
                  electrical signals—thereby producing dynamic and responsive
                  building envelopes.
                </p>

                <p>
                  <strong>Key Features:</strong>
                </p>
                <ul>
                  <li>Break and crack resistance</li>
                  <li>High durability under stress</li>
                  <li>Smooth, optimum finish</li>
                </ul>
              </div>
              <div className="Products_img gap-5 mt-5 wow fadeInUp">
                <img src={ArctitectureGlass1} style={{width : "250px" , height : "250px"}} alt="Bus" />
                <img src={ArctitectureGlass2} style={{width : "250px" , height : "250px"}} alt="car" />
                <img src={ArctitectureGlass3} style={{width : "250px" , height : "250px"}} alt="car" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End */}

      <Footer />
    </div>
  );
};

export default Arctitecture_Glass;
